export default __webpack_public_path__ + "static/most-insane-airbnbs-around-the-world-4e75abe62995b33bdd730b20adea85d2.jpg";